
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/concepts/gateways",
      function () {
        return require("private-next-pages/docs/concepts/gateways.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/concepts/gateways"])
      });
    }
  